module.exports = function () {
    if ( document.querySelector(".scroll-top-btn") ) { 
        document.querySelectorAll(".scroll-top-btn").forEach(button => {
            button.addEventListener("click", () => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                })
            })
            
            if ( document.querySelector( button.dataset.show ) ) {
                const trigger = document.querySelector( button.dataset.show );

                window.addEventListener("scroll", () => {
                    if ( window.scrollY >= trigger.getBoundingClientRect().top ) {
                        button.classList.remove("!invisible");
                    }
                    else {
                        button.classList.add("!invisible");
                    }
                })
            }
        })
    }
}